import { Navigate } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { isAdmin, isAdminEmail } from '@/services/adminService'

interface RequireAdminProps {
  children: React.ReactNode
}

/**
 * Route guard that only allows the configured admin user.
 * Non-admins are redirected to the home page.
 */
export function RequireAdmin({ children }: RequireAdminProps) {
  const { user, isLoading } = useAuth()

  // Show loading spinner while checking auth state
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--color-kids-bg)]">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-[var(--color-kids-primary)] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-[var(--color-kids-text-muted)]">Loading...</p>
        </div>
      </div>
    )
  }

  // Redirect non-admins to home
  if (!user || (!isAdmin(user.id) && !isAdminEmail(user.email))) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
